import { useEffect, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { MdArrowForward } from "react-icons/md";
import { Oval } from "react-loader-spinner";
import RecentDrawsCarousel from "./RecentDrawsCarousel";
import DrawCard from "./DrawCard";
import { getLotteryContract } from "../../web3/getLotteryContract";
import { web3ModalContext } from "../Web3ModalProvider";

export default function RecentDraws() {
  const { web3Modal, web3Data, setWeb3Data, connectWallet } = useContext(web3ModalContext);

  const lotteryContract = getLotteryContract();
  const [lotteryList, setLotteryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const recentDraw = async (lotteryID) => {
    try {
      const lotteryInfo = await lotteryContract.viewLottery(lotteryID);
      const userInfo = await lotteryContract.viewUserInfoForLotteryId(web3Data.account, lotteryID, 0, 1000);
      const lottery = {
        id: lotteryID,
        startTime: lotteryInfo.startTime,
        endTime: lotteryInfo.endTime,
        amountCollected: lotteryInfo.amountCollected,
        ticketCount: lotteryInfo.firstTicketIdNextLottery - lotteryInfo.firstTicketId,
        finalNumber: lotteryInfo.finalNumber,
        status: lotteryInfo.status,
        tickets: userInfo[1],
        ticketsid: userInfo[0],
        ticketsStats: userInfo[2],
      };
      console.log(lotteryInfo, userInfo);
      return lottery;
    } catch (err) {
      console.log(err);
    }
  };

  const getRecentDraws = async () => {
    try {
      const lotteries = [];
      setIsLoading(true);
      const lotteryId = await lotteryContract.currentLotteryId();

      let i = 0;
      while ((lotteryId - i >= 0) && i < 5) {
      // for (let i = 0; i <= lotteryId; i++) {
        const lottery = await recentDraw(lotteryId - i);
        lotteries.push(lottery);
        i++;
      // }
      }
      setLotteryList(lotteries);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  const connect = async () => {
    try {
      const { provider, library, signer, account, network, chainId } = await connectWallet();
      setWeb3Data({ ...web3Data, connected: true, provider, library, signer, account, network, chainId });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (web3Modal?.cachedProvider) {
      connect();
    }
  }, []);

  useEffect(() => {
    if (web3Data.connected) {
      if (web3Data.signer) getRecentDraws();
    }
  }, [web3Data.connected]);

  return (
    <div className="recent-draw container mx-auto">
      <div className="flex flex-row justify-between mb-7">
        <h6>RECENT DRAWS</h6>
        <Link to="list" className="all-link flex items-center button">
          All <MdArrowForward style={{ color: "#fff", marginLeft: "4px" }} />
        </Link>
      </div>

      {isLoading ? (
        <div className="flex items-center justify-center my-16">
          <Oval
            height={48}
            width={48}
            color="#ffffff"
            wrapperStyle={{}}
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="transparent"
            strokeWidth={4}
            strokeWidthSecondary={4}
          />
        </div>
      ) : lotteryList.length > 0 ?
        lotteryList.length < 5 ?
          (
            <div className="recent-draw-carousel mx-auto">
              <div className="carousel-container">
                {lotteryList.map((lottery, i) => <DrawCard lottery={lottery} key={i} />)}
              </div>
            </div>
          ) : (
            <RecentDrawsCarousel>
              {lotteryList.map((lottery, i) => <DrawCard lottery={lottery} key={i} />)}
            </RecentDrawsCarousel>
          ) : <h1 className="text-3xl my-16 text-center">Nothing Lotteries</h1>}
    </div>
  );
}
